export const publicUrl = (u: string) =>
  `${process.env.NEXT_PUBLIC_BASE_PATH}/${u}`.replace(/\/\//g, '/');
